/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';

export default (query = { page : 1, limit : 20 }) => (dispatch) => {
    //dispatch({
    //    type: actions.RESOURCES_REQUEST,
    //});

    return cecSdk
        .resourceConnect()
        .search(query)
        .then((resourceConnects) => {
            //dispatch({
            //    type: actions.RESOURCES_REQUEST_SUCCESS,
            //});
            //dispatch(receiveResources(resources));
            return resourceConnects;
        });
};
